<template lang="pug">
.create
  //- ============ CABEÇALHO ============
  header.create__hero
    .create__hero-grid
    .create__hero-glow.create__hero-glow--blue
    .create__hero-glow.create__hero-glow--red
    .create__hero-inner
      p.create__eyebrow
        span.create__eyebrow-pip
        | Painel do organizador
      h1.create__title Criar Evento
      p.create__sub Monte uma nova etapa: defina datas, local e as categorias que vão competir.

  //- ============ CONTEÚDO ============
  .create__wrap
    .create__denied(v-if="!canCreate")
      FontAwesomeIcon.create__denied-ic(:icon="['fas','lock']")
      .create__denied-text
        strong Acesso restrito
        span Você precisa do papel "Organizador" para criar eventos.

    form.create__card(v-else @submit.prevent="doCreate")
      //- ----- Identificação -----
      section.create__section
        p.create__legend
          span.create__legend-num 01
          | Identificação

        label.field
          span.field__label Nome do evento *
          .field__control
            FontAwesomeIcon.field__ic(:icon="['fas','trophy']")
            input.field__input(
              id="ce-name"
              v-model="name"
              placeholder="Ex.: Copa de Robótica 2026"
            )

        label.field
          span.field__label Detalhes / descrição
          .field__control.field__control--area
            FontAwesomeIcon.field__ic.field__ic--top(:icon="['fas','align-left']")
            textarea.field__input.field__textarea(
              id="ce-desc"
              v-model="description"
              placeholder="Descrição, regras, observações..."
            )

        label.field
          span.field__label Banner / logo do evento
          .banner
            .banner__preview
              img(v-if="banner" :src="banner" alt="")
              FontAwesomeIcon(v-else :icon="['fas','image']")
            label.banner__btn
              FontAwesomeIcon(:icon="['fas','image']")
              | {{ banner ? 'Trocar imagem' : 'Adicionar imagem' }}
              input.banner__input(type="file" accept="image/*" @change="doSelectBanner")

        label.switch(:class="{ 'switch--on': isTest }")
          input.switch__input(type="checkbox" v-model="isTest")
          span.switch__track
            span.switch__thumb
          span.switch__text
            strong Evento de teste
            span Permite gerar e apagar chaves livremente, para simulações. Não use em competições reais.

      //- ----- Quando & onde -----
      section.create__section
        p.create__legend
          span.create__legend-num 02
          | Quando e onde

        .create__grid
          label.field
            span.field__label Data de início
            .field__control
              FontAwesomeIcon.field__ic(:icon="['far','calendar-alt']")
              input.field__input(id="ce-start" type="date" v-model="startat")
          label.field
            span.field__label Data de término
            .field__control
              FontAwesomeIcon.field__ic(:icon="['far','calendar-check']")
              input.field__input(id="ce-end" type="date" v-model="endat")

        label.field
          span.field__label Quantidade de arenas
          .field__control
            FontAwesomeIcon.field__ic(:icon="['fas','vector-square']")
            input.field__input(
              type="number"
              min="1"
              max="20"
              v-model.number="arenas"
              placeholder="1"
            )
          span.field__help Quantas arenas rodam em paralelo. Com 1, as lutas são agendadas em sequência; com 2 ou mais, o agendador marca lutas simultâneas.

        label.field
          span.field__label Local / endereço
          .field__control
            FontAwesomeIcon.field__ic(:icon="['fas','map-marker-alt']")
            input.field__input(
              id="ce-addr"
              v-model="address"
              placeholder="Ginásio, cidade, etc."
            )

      //- ----- Categorias -----
      section.create__section
        p.create__legend
          span.create__legend-num 03
          | Categorias *
          span.create__legend-count(v-if="selectedCategories.length") {{ selectedCategories.length }} selecionada{{ selectedCategories.length > 1 ? 's' : '' }}

        p.create__hint Marque as categorias e informe o máximo de robôs (mínimo 2) de cada uma.

        .create__cats
          label.cat(
            v-for="c in takeCategories"
            :key="c.value"
            :class="{ 'cat--on': selectedCategories.includes(c.value) }"
          )
            input.cat__check(
              type="checkbox"
              :value="c.value"
              v-model="selectedCategories"
            )
            span.cat__box
              FontAwesomeIcon(:icon="['fas','check']")
            span.cat__name {{ c.text }}
            span.cat__max(v-if="selectedCategories.includes(c.value)")
              FontAwesomeIcon.cat__max-ic(:icon="['fas','robot']")
              input.cat__max-input(
                type="number"
                min="2"
                v-model.number="maxRobots[c.value]"
                placeholder="Máx."
                @click.prevent.stop
              )

      transition(name="fade")
        p.create__alert.create__alert--error(v-if="error")
          FontAwesomeIcon(:icon="['fas','exclamation-circle']")
          | {{ error }}
      transition(name="fade")
        p.create__alert.create__alert--ok(v-if="success")
          FontAwesomeIcon(:icon="['fas','check-circle']")
          | Evento criado com sucesso! Redirecionando...

      button.create__submit(type="submit")
        span Criar evento
        FontAwesomeIcon.create__submit-ic(:icon="['fas','arrow-right']")
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'

import { downscaleImage } from '@/utils/image'

export default {
  name: 'CriarEvento',
  data: () => ({
    name: '',
    description: '',
    isTest: false,
    startat: '',
    endat: '',
    address: '',
    arenas: 1,
    selectedCategories: [],
    maxRobots: {},
    banner: '',
    error: '',
    success: false
  }),
  created () {
    this.setCategories()
  },
  computed: {
    ...mapGetters('users', [
      'getUser'
    ]),
    ...mapGetters('categories', [
      'getCategories'
    ]),
    // Organizador (6) ou Admin (1) — mesma regra do backend (create_event).
    canCreate () {
      const roles = this.getUser.roles
      return Array.isArray(roles) && (roles.includes(6) || roles.includes(1))
    },
    takeCategories () {
      return [...this.getCategories].map(c => ({ text: c.name, value: c.id }))
    }
  },
  methods: {
    ...mapActions('categories', [
      'setCategories'
    ]),
    ...mapActions('events', [
      'setCreateEvent',
      'setEvents',
      'setEventImage'
    ]),
    doSelectBanner (e) {
      const files = e.target.files
      if (!files || !files.length) return
      const reader = new FileReader()
      reader.onload = () => {
        downscaleImage(reader.result).then(small => { this.banner = small })
      }
      reader.readAsDataURL(files[0])
    },
    validate () {
      if (!this.name.trim()) return 'Informe o nome do evento.'
      if (!this.selectedCategories.length) return 'Selecione ao menos uma categoria.'
      for (let i = 0; i < this.selectedCategories.length; i++) {
        const max = this.maxRobots[this.selectedCategories[i]]
        if (!max || max < 2) return 'Defina o máximo de robôs (mínimo 2) para cada categoria selecionada.'
      }
      if (this.startat && this.endat && this.endat < this.startat) {
        return 'A data de término deve ser igual ou posterior à data de início.'
      }
      return ''
    },
    doCreate () {
      this.error = ''
      this.success = false
      const message = this.validate()
      if (message) {
        this.error = message
        return
      }
      const categories = this.selectedCategories.map(id => ({
        category_id: id,
        max_robots: this.maxRobots[id]
      }))
      this.setCreateEvent({
        owner: this.getUser.id,
        name: this.name.trim(),
        description: this.description,
        type: 1,
        is_test: this.isTest,
        startat: this.startat || null,
        endat: this.endat || null,
        address: this.address,
        arenas: this.arenas,
        categories
      }).then(response => {
        if (Array.isArray(response) && response.length && response[0].id) {
          const eventId = response[0].id
          const done = () => {
            this.success = true
            this.setEvents()
            setTimeout(() => this.$router.push('/Eventos'), 1200)
          }
          // envia o banner (base64 cru) se houver; o backend redimensiona
          if (this.banner) {
            this.setEventImage({ event_id: eventId, image: this.banner.split('base64,')[1] }).then(done)
          } else {
            done()
          }
        } else {
          this.error = 'Não foi possível criar o evento. Verifique a permissão e os dados informados.'
        }
      })
    }
  },
  watch: {
    // categorias carregam async; garante defaults reativos para max_robots
    getCategories: {
      immediate: true,
      handler (cats) {
        (cats || []).forEach(c => {
          if (this.maxRobots[c.id] === undefined) {
            this.$set(this.maxRobots, c.id, 8)
          }
        })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
$blue: #287AED
$blue-dark: #0F4FA8
$red: #DD3434
$red-dark: #B0231F
$green: #2E9E4F
$green-dark: #1F7C3C
$ink: #0B0E14
$paper: #FFFFFF
$muted: #5C6673
$line: rgba(11, 14, 20, 0.10)
$mist: #EEF1F6
$page: #F2F4F8

$display: 'Saira Condensed', 'Lato', sans-serif
$mono: 'Space Mono', 'Lato', monospace

.create
  color: $ink
  background: $page
  min-height: calc(100vh - 64px)
  font-family: Lato, sans-serif

  *
    box-sizing: border-box

  // ---------- CABEÇALHO ----------
  &__hero
    position: relative
    overflow: hidden
    isolation: isolate
    padding: 54px 0 60px
    background: radial-gradient(circle at 16% 8%, #15233b 0%, $ink 52%, #05070b 100%)
    color: #fff

  &__hero-grid
    position: absolute
    inset: 0
    background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
    background-size: 42px 42px
    mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
    -webkit-mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
    z-index: -2

  &__hero-glow
    position: absolute
    width: 360px
    height: 360px
    border-radius: 50%
    filter: blur(110px)
    opacity: 0.5
    z-index: -1
    &--blue
      background: $blue
      top: -150px
      left: -90px
    &--red
      background: $red
      bottom: -180px
      right: -80px

  &__hero-inner
    position: relative
    max-width: 760px
    margin: 0 auto
    padding: 0 24px
    > *
      animation: ce-rise .6s cubic-bezier(.2, .7, .2, 1) both
    .create__eyebrow
      animation-delay: .04s
    .create__title
      animation-delay: .10s
    .create__sub
      animation-delay: .16s

  &__eyebrow
    display: inline-flex
    align-items: center
    gap: 10px
    font-family: $mono
    text-transform: uppercase
    letter-spacing: 0.22em
    font-size: 12px
    font-weight: 700
    color: rgba(255, 255, 255, 0.7)
    margin: 0 0 14px

  &__eyebrow-pip
    width: 8px
    height: 8px
    border-radius: 50%
    background: linear-gradient(135deg, #5AA0FF, $red)
    box-shadow: 0 0 0 4px rgba(40, 122, 237, 0.18)

  &__title
    font-family: $display
    font-weight: 800
    text-transform: uppercase
    font-size: clamp(40px, 6vw, 66px)
    line-height: 0.94
    letter-spacing: -0.015em
    margin: 0

  &__sub
    font-size: 17px
    color: rgba(255, 255, 255, 0.74)
    margin: 16px 0 0
    max-width: 520px

  // ---------- CONTEÚDO ----------
  &__wrap
    max-width: 760px
    margin: 0 auto
    padding: 0 24px 72px

  &__card
    margin-top: -28px
    position: relative
    z-index: 1
    background: $paper
    border: 1px solid $line
    border-radius: 18px
    padding: 36px 34px
    box-shadow: 0 22px 50px rgba(11, 14, 20, 0.12)
    animation: ce-rise .55s cubic-bezier(.2, .7, .2, 1) both
    animation-delay: .2s

  // ---------- DENIED ----------
  &__denied
    margin-top: -28px
    position: relative
    z-index: 1
    display: flex
    align-items: center
    gap: 18px
    padding: 26px 28px
    background: $paper
    border: 1px solid rgba(221, 52, 52, 0.22)
    border-left: 4px solid $red
    border-radius: 16px
    box-shadow: 0 22px 50px rgba(11, 14, 20, 0.10)
    &-ic
      font-size: 26px
      color: $red
      flex-shrink: 0
    &-text
      display: flex
      flex-direction: column
      gap: 4px
      strong
        font-family: $display
        text-transform: uppercase
        font-size: 20px
      span
        color: $muted
        font-size: 15px

  // ---------- SEÇÕES ----------
  &__section
    padding: 0 0 28px
    margin-bottom: 28px
    border-bottom: 1px solid $line
    &:last-of-type
      border-bottom: none
      padding-bottom: 4px
      margin-bottom: 0

  &__legend
    display: flex
    align-items: center
    gap: 12px
    font-family: $display
    text-transform: uppercase
    letter-spacing: 0.01em
    font-size: 22px
    font-weight: 700
    margin: 0 0 18px

  &__legend-num
    font-family: $mono
    font-size: 12px
    font-weight: 700
    color: $blue
    background: rgba(40, 122, 237, 0.10)
    border-radius: 8px
    padding: 4px 9px
    letter-spacing: 0

  &__legend-count
    margin-left: auto
    font-family: $mono
    font-size: 11px
    font-weight: 700
    letter-spacing: 0.06em
    text-transform: none
    color: $blue-dark
    background: rgba(40, 122, 237, 0.10)
    border-radius: 999px
    padding: 4px 11px

  &__hint
    margin: -8px 0 16px
    font-size: 14px
    color: $muted

  &__grid
    display: grid
    grid-template-columns: 1fr 1fr
    gap: 16px

  // ---------- ALERTAS ----------
  &__alert
    display: flex
    align-items: center
    gap: 9px
    margin: 0 0 18px
    padding: 12px 14px
    border-radius: 10px
    font-size: 14px
    &--error
      color: $red-dark
      background: rgba(221, 52, 52, 0.08)
      border: 1px solid rgba(221, 52, 52, 0.22)
    &--ok
      color: $green-dark
      background: rgba(46, 158, 79, 0.10)
      border: 1px solid rgba(46, 158, 79, 0.25)

  // ---------- SUBMIT ----------
  &__submit
    display: inline-flex
    align-items: center
    justify-content: center
    gap: 10px
    height: 54px
    padding: 0 30px
    border: none
    border-radius: 10px
    cursor: pointer
    font-family: $display
    font-weight: 600
    text-transform: uppercase
    letter-spacing: 0.06em
    font-size: 17px
    color: #fff
    background: $blue
    box-shadow: 0 10px 24px rgba(40, 122, 237, 0.35)
    transition: transform .18s ease, box-shadow .18s ease, background .18s ease
    &:hover
      background: $blue-dark
      transform: translateY(-2px)
      box-shadow: 0 14px 30px rgba(40, 122, 237, 0.45)
    &-ic
      font-size: 13px
      transition: transform .2s ease
    &:hover &-ic
      transform: translateX(4px)

  // ---------- CAMPO ----------
  .field
    display: flex
    flex-direction: column
    margin-bottom: 16px
    &:last-child
      margin-bottom: 0
    &__label
      font-family: $mono
      text-transform: uppercase
      letter-spacing: 0.1em
      font-size: 11px
      font-weight: 700
      color: $muted
      margin-bottom: 8px
    &__control
      position: relative
      display: flex
      align-items: center
      border: 1px solid $line
      border-radius: 10px
      background: #fff
      transition: border-color .18s ease, box-shadow .18s ease
      &:focus-within
        border-color: $blue
        box-shadow: 0 0 0 4px rgba(40, 122, 237, 0.12)
      &--area
        align-items: flex-start
    &__help
      margin-top: 7px
      font-size: 12.5px
      line-height: 1.45
      color: $muted
    &__ic
      position: absolute
      left: 16px
      font-size: 15px
      color: $muted
      pointer-events: none
      &--top
        top: 16px
    &__input
      flex: 1
      width: 100%
      box-sizing: border-box
      border: none
      background: none
      outline: none
      height: 52px
      padding: 0 16px 0 44px
      font-size: 15px
      color: $ink
      font-family: Lato, sans-serif
      &::placeholder
        color: rgba(92, 102, 115, 0.55)
    &__textarea
      height: auto
      min-height: 104px
      padding: 14px 16px 14px 44px
      resize: vertical
      line-height: 1.5

  // ---------- BANNER ----------
  .banner
    display: flex
    align-items: center
    gap: 16px
    &__preview
      display: grid
      place-items: center
      flex-shrink: 0
      width: 96px
      height: 60px
      border-radius: 10px
      overflow: hidden
      font-size: 22px
      color: #fff
      background: linear-gradient(135deg, $blue, $blue-dark 55%, $red)
      img
        width: 100%
        height: 100%
        object-fit: cover
    &__btn
      display: inline-flex
      align-items: center
      gap: 8px
      cursor: pointer
      font-family: $mono
      font-size: 12px
      font-weight: 700
      text-transform: uppercase
      letter-spacing: 0.04em
      color: $blue
      background: rgba(40, 122, 237, 0.08)
      border: 1px solid rgba(40, 122, 237, 0.28)
      border-radius: 8px
      padding: 10px 14px
      transition: background .18s ease
      &:hover
        background: rgba(40, 122, 237, 0.16)
    &__input
      display: none

  // ---------- TOGGLE (evento de teste) ----------
  .switch
    display: flex
    align-items: center
    gap: 14px
    margin-top: 18px
    padding: 14px 16px
    border: 1px solid $line
    border-radius: 12px
    background: #fff
    cursor: pointer
    transition: border-color .18s ease, background .18s ease
    &--on
      border-color: rgba(40, 122, 237, 0.5)
      background: rgba(40, 122, 237, 0.05)
      .switch__track
        background: $blue
      .switch__thumb
        transform: translateX(20px)
    &__input
      position: absolute
      opacity: 0
      width: 0
      height: 0
    &__track
      position: relative
      flex-shrink: 0
      width: 46px
      height: 26px
      border-radius: 999px
      background: #C4C9D2
      transition: background .18s ease
    &__thumb
      position: absolute
      top: 3px
      left: 3px
      width: 20px
      height: 20px
      border-radius: 50%
      background: #fff
      box-shadow: 0 1px 3px rgba(11, 14, 20, 0.3)
      transition: transform .18s ease
    &__text
      display: flex
      flex-direction: column
      gap: 2px
      strong
        font-size: 15px
        font-weight: 700
        color: $ink
      span
        font-size: 13px
        color: $muted

  // ---------- CATEGORIAS ----------
  &__cats
    display: grid
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 220px), 1fr))
    gap: 12px

  .cat
    display: flex
    align-items: center
    gap: 12px
    padding: 14px 16px
    border: 1px solid $line
    border-radius: 12px
    background: #fff
    cursor: pointer
    transition: border-color .18s ease, box-shadow .18s ease, background .18s ease
    &:hover
      border-color: rgba(40, 122, 237, 0.4)
    &--on
      border-color: $blue
      background: rgba(40, 122, 237, 0.05)
      box-shadow: 0 0 0 3px rgba(40, 122, 237, 0.10)
      .cat__box
        background: $blue
        border-color: $blue
        svg
          opacity: 1
          transform: scale(1)

    &__check
      position: absolute
      opacity: 0
      width: 0
      height: 0

    &__box
      display: grid
      place-items: center
      flex-shrink: 0
      width: 22px
      height: 22px
      border-radius: 6px
      border: 2px solid #C4C9D2
      color: #fff
      font-size: 11px
      transition: background .18s ease, border-color .18s ease, transform .18s ease
      svg
        opacity: 0
        transform: scale(.5)
        transition: opacity .15s ease, transform .15s ease

    &__name
      flex: 1
      min-width: 0
      font-weight: 600
      font-size: 15px

    &__max
      display: inline-flex
      align-items: center
      gap: 6px
      flex-shrink: 0
      padding: 0 10px
      height: 36px
      border-radius: 8px
      background: $mist
      &-ic
        font-size: 12px
        color: $blue
      &-input
        width: 46px
        border: none
        background: none
        outline: none
        font-family: $mono
        font-weight: 700
        font-size: 14px
        color: $ink
        text-align: center
        // remove spinners
        -moz-appearance: textfield
        appearance: textfield
        &::-webkit-outer-spin-button, &::-webkit-inner-spin-button
          -webkit-appearance: none
          margin: 0

  // ---------- transições ----------
  .fade-enter-active, .fade-leave-active
    transition: opacity .25s ease
  .fade-enter, .fade-leave-to
    opacity: 0

@keyframes ce-rise
  from
    opacity: 0
    transform: translateY(16px)
  to
    opacity: 1
    transform: none

// ---------- responsivo ----------
@media (max-width: 620px)
  .create__hero
    padding: 38px 0 50px
  .create__hero-inner
    padding: 0 18px
  .create__wrap
    padding: 0 18px 56px
  .create__card
    padding: 26px 20px
  .create__grid
    grid-template-columns: 1fr
  .create__submit
    width: 100%
</style>
